import { useContext } from 'react';
import { ResellerReportContext } from '../Contexts/ResellerReportContext';

export const useResellerReport = () => useContext(ResellerReportContext);
